export default "__VITE_ASSET__d52aa414__"